@if (messages$ | async; as messages) {
  @for (message of messages; track message) {
    <p-message
      [closable]="message.closable"
      [styleClass]="styleClass()"
      [severity]="toMessageSeverity(message.severity)">
      @if (shouldShowSummary(message.summary)) {
        <div>{{ message.summary }}</div>
      }
      @if (shouldShowDetail(message.detail)) {
        <div class="font-normal">{{ message.detail }}</div>
      }
    </p-message>
  }
}
